// extracted by mini-css-extract-plugin
export default {"invisible":"users-summary-table_invisible__r+EG5"};